var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconSaveBlue(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1242 1.29083C13.7758 0.9425 13.3083 0.75 12.8225 0.75H2.58333C1.56583 0.75 0.75 1.575 0.75 2.58333V15.4167C0.75 16.425 1.575 17.25 2.58333 17.25H15.4167C16.425 17.25 17.25 16.425 17.25 15.4167V5.1775C17.25 4.69167 17.0575 4.22417 16.7092 3.885L14.1242 1.29083ZM9 15.4167C7.47833 15.4167 6.25 14.1883 6.25 12.6667C6.25 11.145 7.47833 9.91667 9 9.91667C10.5217 9.91667 11.75 11.145 11.75 12.6667C11.75 14.1883 10.5217 15.4167 9 15.4167ZM9.91667 6.25H4.41667C3.40833 6.25 2.58333 5.425 2.58333 4.41667C2.58333 3.40833 3.40833 2.58333 4.41667 2.58333H9.91667C10.925 2.58333 11.75 3.40833 11.75 4.41667C11.75 5.425 10.925 6.25 9.91667 6.25Z",
    fill: "#378EF0"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSaveBlue);
export default __webpack_public_path__ + "static/media/icon_save_blue.83a10226f0ecd204b5d556609f83b479.svg";
export { ForwardRef as ReactComponent };